var React = require('react');

function EyeSlash (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m4.5 3.75 15 16.5M14.523 14.775a3.75 3.75 0 0 1-5.046-5.55","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M6.937 6.43C3.115 8.367 1.5 12 1.5 12s3 6.75 10.5 6.75c1.757.013 3.493-.392 5.062-1.181M19.557 15.853C21.601 14.023 22.5 12 22.5 12s-3-6.75-10.5-6.75c-.65-.002-1.298.051-1.939.157","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M12.706 8.316a3.752 3.752 0 0 1 3.028 3.331","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2})]);
}

EyeSlash.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = EyeSlash;

EyeSlash.default = EyeSlash;
